import React from "react";
import { Box, Drawer, useTheme } from "@mui/material";
import DrawerHeader from "./DrawerHeader";

const StyledDrawer = ({
  show,
  title,
  onClose,
  ContentComponent,
  contentProps = {},
  width = "50vw",
  isLoading = false,
}) => {
  const theme = useTheme();
  const anchor = theme.direction === "rtl" ? "left" : "right";

  if (!show) return null;

  return (
    <Drawer anchor={anchor} open={show} onClose={onClose}>
      <Box
        sx={{
          width: width,
          minWidth: "400px",
          flexGrow: 1,
          height: "100%",
          display: "flex",
          flexDirection: "column",
        }}
        role="presentation"
      >
        <DrawerHeader
          title={title}
          isLoading={isLoading}
          onClose={onClose}
        ></DrawerHeader>

        <Box sx={{ mt: 2, flex: 1, display: "flex", flexDirection: "column" }}>
          <ContentComponent {...contentProps} />
        </Box>
      </Box>
    </Drawer>
  );
};

export default StyledDrawer;
